import { WiDaySunny, WiNightClear } from "react-icons/wi";

export function WeatherIcon({ code, isDay = true, size = 24, color = "#f7a81b" }) {
  // just show sun/moon for simplicity, ignore code
  const Icon = isDay ? WiDaySunny : WiNightClear;
  return <Icon size={size} color={color} />;
}